import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'seo-suppliers_page_most_popular_carousel_product_tile-click';

/**
 * track clicking on product tile on most popular brands carousel on brand results page
 */
export function trackSeoSuppliersPageMostPopularCarouselProductTileClick(
  productToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { productToken },
  });
}
